/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";

import Logo from "./brand/logo";
import Internacionalization from "./internacionalization/internacionalization";
import Social from "./social/social";
import Auth from "./auth/auth";

function Header() {
  const { logged, user } = useSelector((store) => store.auth);

  return (
    <header className="theme-header">
      <div className="container">
        <div className="row">
          <div className="col-12 header-main">
            <div className="header-col-3 header-col1">
              <Logo />

              <Internacionalization />
            </div>
            <div className="header-col-3 header-col2">
              <Social />
            </div>

            <div className="header-col-3 justify-content-btw header-col3">
              <div className="toggle-btn view-below990">
                <button type="button" className="toggle-btn">
                  <i className="fal fa-bars"></i>
                </button>
              </div>
              <div className="sm-toggle-warp">
                <div className="close-btn view-below990">
                  <div className="close-btn-inner">
                    <button type="button" className="toggle-close-btn">
                      <i className="fal fa-times"></i>
                    </button>
                  </div>
                </div>
                <div className="game-btn-warp">
                  <a href={t("Config.MainSite")}>
                    <span className="icon">
                      <img src="/images/game-icon.png" alt="" />
                    </span>
                  </a>
                  {logged && (
                    <>
                      <Link to={DefRoutes.RechargeCenter}>
                        <span className="icon">
                          <img src="/images/doller-icon.png" alt="" />
                        </span>
                      </Link>
                      <Link to={DefRoutes.LoyalMember}>
                        <span className="icon">
                          <img src="/images/crown-icon.png" alt="" />
                        </span>
                      </Link>
                      <Link to={DefRoutes.Support}>
                        <span className="icon">
                          <img src="/images/face-icon.png" alt="" />
                        </span>
                      </Link>
                    </>
                  )}
                </div>

                {!logged && <Auth />}

                {logged && (
                  <div className="user-profile-btn">
                    <div className="dropdown">
                      <a
                        className="btn dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span className="thumb">
                          <img src={user.avatar || "/images/user-thumb.png"} alt="" />
                        </span>
                        {user.nickname}
                      </a>

                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                        <li>
                          <Link className="dropdown-item" to={DefRoutes.Profile}>
                            <span className="nav-icon">
                              <img src="/images/config-icon.png" alt="" />
                            </span>
                            {t("Menu.Config")}
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to={DefRoutes.Logout}>
                            <span className="nav-icon">
                              <img src="/images/logout-icon.png" alt="" />
                            </span>
                            {t("Menu.Logout")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
